import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Nav from "./sections/Nav";

/* Account Balance Routes */
import AccountBalance from "./routes/accountBalance/AccountBalance";
import AddAccountBalance from "./routes/accountBalance/AddAccountBalance";
import AddAccountBalances from "./routes/accountBalance/AddAccountBalances";
import UpdateAccountBalance from "./routes/accountBalance/UpdateAccountBalance";

/* Frontend Routes */
import HomeStyleGuide from "./routes/frontend/HomeStyleGuide";
import LavellaDashboard from "./routes/lavellaLife/LavellaDashboard";
import Login from "./routes/Login";
import SpendingAveragesPage from "./routes/lavellaLife/SpendingAveragesPage";
import LedgerPage from "./routes/lavellaLife/LedgerPage";
import AccountsPage from "./routes/lavellaLife/AccountsPage";

function App() {
	const [loggedInUser, setLoggedInUser] = useState(localStorage.getItem("loggedInUser"));
	return (
		<div className="app lavella">
			<NavWrapper loggedInUser={loggedInUser} setLoggedInUser={setLoggedInUser} />
			<main>
				<Routes>
					<Route path="/login" element={<Login setLoggedInUser={setLoggedInUser} />} />
					{!loggedInUser ? (
						<Route path="*" element={<Login setLoggedInUser={setLoggedInUser} />} />
					) : (
						<>
							<Route path="/" element={<LavellaDashboard username={loggedInUser} />} />
							<Route path="/dashboard" element={<LavellaDashboard username={loggedInUser} />} />
							<Route path="/spending-averages" element={<SpendingAveragesPage />} />
							<Route path="/accounts" element={<AccountsPage />} />
							<Route path="/ledger" element={<LedgerPage />} />
							<Route path="/style-guide" element={<HomeStyleGuide />} />
							<Route path="/accountBalance" element={<AccountBalance />} />
							<Route path="/addAccountBalance" element={<AddAccountBalance />} />
							<Route path="/addAccountBalances/:group" element={<AddAccountBalances />} />
							<Route path="/updateAccountBalance/:id" element={<UpdateAccountBalance />} />
						</>
					)}
				</Routes>
			</main>
		</div>
	);
}

function NavWrapper({ loggedInUser, setLoggedInUser }) {
	if (!loggedInUser) return null;
	return <Nav setLoggedInUser={setLoggedInUser} />;
}

export default App;
